import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    paper: {
      borderRadius: 10,
      boxShadow: "0 3px 6px 0 rgba(0,0,0,.25)",
      position: "relative",
      overflowY: "initial",
      transition: "height 150ms ease-in-out",
      [theme.breakpoints.up("mobile")]: {
        borderRadius: 20,
      },
    },
    dialogContent: {
      padding: 0,
    },
  }),
  { name: "ShareModal" },
);
